import clsx from 'clsx';
import { Order } from '../api-new';
import { ConfirmOrdersIcon } from '../icons/confirm-orders';
import { PlaneIcon } from '../icons/plane';
import { COLS_COMPACT } from './columns';
import { TH } from '../shared/table';

export const OrdersSubmission = (ps: {
  orders: Order[];
  onRemove: (id: number) => void;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  return (
    <div
      className="fixed top-[90px] left-0 w-full backdrop-blur bg-neutral-300/50"
      style={{ height: 'calc(100vh - 90px)' }}
      onClick={ps.onClose}>
      <div
        className="absolute top-10 bottom-10 left-40 right-40 rounded-xl border-4 border-blue-500 bg-white flex flex-col p-6"
        onClick={(e) => e.stopPropagation()}>
        <div className="h-20">
          <h1 className="flex items-center gap-4 text-2xl font-bold">
            <ConfirmOrdersIcon className="h-6 w-6 fill-black" /> Rivedi{' '}
            {ps.orders.length} Ordini Selezionati
          </h1>
          <p className="my-2 text-neutral-500 text-sm">
            Controlla e modifica la selezione di ordini da inviare in
            produzione.
          </p>
        </div>
        <div style={{ height: 'calc(100% - 11rem)' }} className="overflow-auto">
          <table className="w-full">
            <thead>
              <tr>
                <TH className="py-5 text-center">#</TH>
                {COLS_COMPACT.map((col, i) => (
                  <TH key={i} className="py-5">
                    {col.label}
                  </TH>
                ))}
                <TH className="py-5" />
              </tr>
            </thead>
            <tbody>
              {ps.orders.map((order, i) => (
                <tr key={order.wk_id} className="group">
                  <td className="group-even:bg-neutral-100 px-1 py-5 text-center border-b text-blue-500 font-bold">
                    {i + 1}
                  </td>
                  {COLS_COMPACT.map((col, i) => (
                    <td
                      key={i}
                      className={clsx(
                        'group-even:bg-neutral-100 py-5 px-1',
                        col.truncate &&
                          'text-ellipsis max-w-1 overflow-hidden whitespace-nowrap',
                      )}>
                      {col.cell ? col.cell(order) : order[col.key]}
                    </td>
                  ))}
                  <td className="group-even:bg-neutral-100 px-2 py-5 border-b text-center">
                    <div
                      className="cursor-pointer text-xs font-bold leading-none h-5 w-5 rounded-full aspect-square bg-neutral-600 text-white hover:scale-105 flex items-center justify-center"
                      onClick={() => ps.onRemove(order.wk_id)}>
                      X
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="h-24 flex items-center justify-end gap-2 p-4 font-bold">
          <div
            className="cursor-pointer rounded-lg border-2 border-neutral-400 text-neutral-400 px-8 py-4 transition-transform hover:scale-105"
            onClick={ps.onClose}>
            Annulla
          </div>
          <div
            className={clsx(
              'rounded-lg bg-blue-500 text-white p-4 flex items-center gap-4 transition-transform ',
              ps.orders.length > 0
                ? 'cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed',
            )}
            onClick={() => {
              if (ps.orders.length > 0) return;
              ps.onSubmit();
            }}>
            <PlaneIcon className="h-6 w-6" /> Invia in produzione
          </div>
        </div>
      </div>
    </div>
  );
};
